import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '@lite-workspace/shared/blocks/icon';

// The one «личные ссылки» stub look for every surface that used to hand out the class link
// (organizer dialog, faces completion screen) — projected text differs, the shell must not drift.
@Component({
  selector: 'app-personal-links-stub',
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex items-start gap-3 rounded-[var(--r-l)] border border-line bg-bg2 px-3 py-2.5 text-left md:px-4 md:py-3.5">
      <span class="grid size-8 shrink-0 place-items-center rounded-[var(--r-l)] bg-panel2 text-c2 md:size-9">
        <app-icon name="lock-close" [size]="16" />
      </span>
      <p class="text-sm leading-normal text-c2"><ng-content /></p>
    </div>
  `,
})
export class PersonalLinksStubComponent {}
